/**
 * Authored LMN (Letter of Medical Necessity) tile/modal copy — the single source
 * of fallback truth shared by the server fetch (`lmn-content.server.ts`) and the
 * client modal (`whats-lmn-button.tsx`), so the two can't drift (SFCC-11677).
 *
 * Verbatim from the published FSA/HSA Builder `site-preferences` entries. Used
 * when Builder omits a field or is unreachable, so the modal/CTA/badge always
 * render correct copy rather than blank. Plain module (no `.server`) so it's safe
 * to import into client components.
 */
export const LMN_FALLBACK_MODAL_TITLE = "What's an LMN?";

export const LMN_FALLBACK_MODAL_CONTENT =
  "You can now unlock expanded eligibility on products and services that aren’t typically covered by your FSA with a Letter of Medical Necessity (LMN).\n\nWe partner only with brands that make LMN process easy, so you can access the personalized care you need.\n\nWhen you select a product on our site that requires an LMN, you’ll be taken to a third party site where you can use your FSA/HSA card at checkout.";

export const LMN_FALLBACK_CTA = "Get Started";

export const LMN_FALLBACK_BADGE_COLOR = "rgba(205, 59, 95, 1)";
